import { styled } from "styled-components";

export const ApiDocumentationWrapper = styled.div`
  width: 100%;
  background-color: ${({ theme }) => theme.colors.default[50]};
  display: flex;
  justify-content: center;
`;

export const ApiDocumentationContainer = styled.div`
  display: flex;
  padding: 60px 48px 48px 48px;
  flex-direction: column;
  align-items: flex-start;
  max-width: ${({ theme }) => theme.content.maxWidth}px;
  gap: 48px;
  & > a {
    color: ${({ theme }) => theme.colors.primary[600]};
  }
`;

export const DocumentationCardsContainer = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 12px;
  flex-wrap: wrap;

  ${({ theme }) => theme.breakpoints.sm.query} {
    justify-content: center;
  }
`;

export const TitleContainer = styled.div``;
